export default "__VITE_ASSET__CnG1SD_k__"